/**
 * Decision prompts are generic: the sheet, its scrim and its lifecycle are the
 * same for every game, and only the body is per-game. `actions.pending` is the
 * only trigger — the client never works out that a decision is owed.
 */
import type { ReactNode } from 'react'

export function Sheet({ children, onDismiss }: { children: ReactNode; onDismiss?: () => void }): JSX.Element {
  return (
    <div className="sheet-scrim" onClick={onDismiss}>
      <div className="sheet" onClick={(e) => e.stopPropagation()}>
        {children}
      </div>
    </div>
  )
}
